export const canvasBody = {
    width: "300px"
};

export const imageSizeBoxes = {
    width: "60px"
};
